import * as React from 'react';
import NumberFormat from 'react-number-format';
import { useMutation } from 'react-query';

import Button from '@healthme/core/Button/Index';
import RadioField from '@healthme/core/Form/RadioField/Index';
import Modal from '@healthme/core/Modal/Index';
import purchaseAPI from '@healthme/services/api/purchases/Index';
import { centsToDollars } from '@healthme/utility/Utils';

import { ErrorMessage } from '../ErrorMessage/Index';
import Icon from '../Icon/Index';
import SuccessMessage from '../SuccessMessage/Index';
import style from '../timepicker/style';

export interface IRefundRequestModalProps {
	openModal: boolean;
	payment: any;
	onClose: () => void;
	showPreviousStep?: boolean;
}

export function RefundRequestModal(props: IRefundRequestModalProps) {
	//USE STATE
	const [refundError, setRefundError] = React.useState('');
	const [refundReason, setRefundReason] = React.useState('cancellation');
	const [successMessage, setSuccessMessage] = React.useState(false);

	//REACT QUERY
	const { mutate: mutateRefund, isLoading } = useMutation(
		item => purchaseAPI.post({}, `/${props.payment.id}/request_refund?reason=${refundReason}`),
		{
			onSuccess: () => {
				setSuccessMessage(true);
				handleModalClose();
			},
			onError: (err: any) => {
				try {
					if (err?.data) {
						const error = JSON.parse(err.data);
						setRefundError(error?.error);
					}
				} catch (e) {
					setRefundError('Server Error - Please contact HealthMe Support.');
				}
			},
		}
	);
	/*
	 **-------------------------------------------------------------------------------------
	 ** FN NAME - handleModalClose
	 **-------------------------------------------------------------------------------------
	 */
	const handleModalClose = () => {
		setRefundError('');
		props.onClose();
	};
	/*
	 **-------------------------------------------------------------------------------------
	 ** FN NAME - sendRefund
	 **-------------------------------------------------------------------------------------
	 */
	const sendRefund = () => {
		mutateRefund();
	};
	return (
		<>
			<Modal maxWidth="sm" open={props.openModal} onClose={handleModalClose}>
				{props.showPreviousStep && (
					<a onClick={() => handleModalClose()} className="text-link font-semibold">
						<Icon type="LeftArrow" classNames="w-2 icon-blue inline-block ml-5 mr-2" />{' '}
						Previous Step
					</a>
				)}
				{refundError.length > 0 && <ErrorMessage message={refundError} />}
				<SuccessMessage
					message="Refund Successfully Requested."
					open={successMessage}
					onClose={setSuccessMessage}
				/>

				<div className="">
					<p className="text-center text-h3 mb-1 font-semibold">Request Refund</p>
					<p className="text-center text-p">
						Refund request will be processed in 1-2 days.
					</p>
					{/* <div className="flex flex-wrap justify-center gap-16 mt-10 text-p ">
						<div className="  " style={{ maxWidth: '100px', whiteSpace: 'normal' }}>
							<strong className="block mb-1">Package:</strong>
							{props.payment.claimed_package?.title}
						</div>
						<div>
							<strong className="block mb-1">Price:</strong>
							<NumberFormat
								displayType={'text'}
								thousandSeparator={true}
								prefix={'$'}
								value={centsToDollars(props.payment.amount)}
								decimalSeparator="."
								decimalScale={2}
								fixedDecimalScale={true}
							/>
						</div>
						<div>
							<strong className="block mb-1">Purchaser Name:</strong>
							{props.payment?.payee?.first_name} {props.payment?.payee?.last_name}
						</div>
					</div> */}
					<div className="flex justify-between mt-5 px-16">
						<div className="">
							<RadioField
								value="cancellation"
								selected={refundReason}
								text="Cancellation"
								onChange={setRefundReason}
								className="my-2"
							/>
						</div>
						<div className="">
							<RadioField
								value="accidental_purchase"
								selected={refundReason}
								text="Accidental Purchase"
								onChange={setRefundReason}
								className="my-2"
							/>
						</div>
						<div className="">
							<RadioField
								value="other"
								selected={refundReason}
								text="Other"
								onChange={setRefundReason}
								className="my-2"
							/>
						</div>
					</div>
					<div className="mt-5 flex flex-wrap justify-center">
						<div className="w-9/12">
							<Button
								disabled={isLoading}
								onClick={sendRefund}
								extraClasses="w-full max-w-full"
							>
								Submit Request
							</Button>
						</div>
					</div>
				</div>
			</Modal>
		</>
	);
}
